export default __webpack_public_path__ + "4a5db114c46f3ef415af276618037f86.png";